if (!customElements.get("card-swatch")) {
	customElements.define(
		"card-swatch",
		class CardSwatches extends HTMLElement {
			constructor() {
				super();
				this.init();
			}

			init() {
				this.addEventListener("click", (e) => {
					e.preventDefault();
					const productUrl = this.dataset.productUrl;
					this.renderProduct(productUrl);
				});
			}
			async renderProduct(productUrl) {
				try {
					const response = await fetch(
						`${location.origin}${productUrl}?view=product-card`
					);
					const html = await response.text();
					const html_ = new DOMParser().parseFromString(html, "text/html");
					const productGrid = html_.querySelector(".product-card-wrapper");

					if (productGrid) {
						const targetElement = this.closest(".product-card-wrapper");
						if (targetElement) {
							targetElement.innerHTML = productGrid.innerHTML;
							document.dispatchEvent(new CustomEvent("swatch-more-card:init"));
							affirm?.ui?.refresh();
						}
					}
				} catch (error) {
					console.error("Error fetching product details:", error);
				}
			}
		}
	);
}
